import * as React from "react";
import stringToColor from "string-to-color";
import Color from "color";
import { User as UserIcon } from "react-feather";
import { FastAverageColor } from "fast-average-color";
import { Badge } from "antd";
import { LockTwoTone } from "@ant-design/icons";
import { useAppSelector } from "../../../../store/hooks";
import { selectHasOrgInvite, selectOrgInvites } from "../../../../store/userDataSlice";
import { selectAvatarInitials, selectIsAdmin } from "../../../../store/userSlice";

interface Props {
  size: number;
  // show tasks count and isSaml icon
  showAdditions?: boolean;
}
export const UserAvatar: React.FC<Props> = ({ size = 32, showAdditions = false }) => {
  const hasOrgInvite = useAppSelector(selectHasOrgInvite);
  const orgInvites = useAppSelector(selectOrgInvites);
  const avatarInitials = useAppSelector(selectAvatarInitials);

  const userEmail = useAppSelector((state) => state.user.email);
  const photoUrl = useAppSelector((state) => state.user.photoUrl);
  const isAdmin = useAppSelector(selectIsAdmin);
  const isSaml = useAppSelector((state) => state.user.isSaml);

  const [avatarColor, setAvatarColor] = React.useState(stringToColor(userEmail.split("@")[0]));
  const [imageAverageColor, setImageAverageColor] = React.useState<string | null>(null);

  React.useEffect(() => {
    let iteration = 0;
    let maxIteration = 10;
    let color = Color(avatarColor);
    while (color.luminosity() > 0.3 && iteration < maxIteration) {
      iteration += 1;
      color = color.darken(0.1);
    }
    setAvatarColor(color.hex());
  }, []);

  React.useEffect(() => {
    getAverageColor();
  }, []);

  async function getAverageColor() {
    try {
      const fac = new FastAverageColor();
      const color = await fac.getColorAsync(photoUrl);
      setImageAverageColor(color.hex);
    } catch (e) {
      setImageAverageColor(null);
    }
  }

  return (
    <Badge count={showAdditions && hasOrgInvite ? orgInvites.length : undefined} size="small">
      <div className="nguser-avatar-container">
        <div className="nguser-avatar" style={{ backgroundColor: avatarColor, width: size, height: size }}>
          {photoUrl ? (
            <img className="nguser-avatar-image" src={isAdmin ? undefined : photoUrl} />
          ) : avatarInitials ? (
            <span
              className={`nguser-avatar-initials ${avatarInitials.length > 2 ? "nguser-avatar-initials-large" : ""}`}
            >
              {avatarInitials}
            </span>
          ) : (
            <UserIcon />
          )}
        </div>
        {isSaml && showAdditions ? (
          <LockTwoTone
            className="nguser-avatar-lock"
            color={imageAverageColor || avatarColor}
            style={{
              right: -7,
              top: 20,
              width: 15,
              height: 15,
            }}
          />
        ) : null}
      </div>
    </Badge>
  );
};
